/* eslint-disable react/prop-types */
// CustomCheckedIcon.js
import React from 'react';
import { Box } from '@mui/material';
import CheckBoxTick from '../../../images/checkBox-tick.svg'; // Update path

const CustomCheckedIcon = ({ color }) => (
  <Box
    sx={{
      width: 18,
      height: 18,
      border: `1px solid ${color}`,
      borderRadius: '3px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: color,
    }}
  >
    <Box component="img" src={CheckBoxTick} alt="Check box Tick" />
  </Box>
);

export default CustomCheckedIcon;
